import type { BookPageDraft, BookPageLangContent } from './types';

export function defaultPageLangContent(): BookPageLangContent {
  return {
    full_text: '',
  };
}

export function newBookPageDraft(enabledLangIds: string[], pageNumber: number): BookPageDraft {
  const byLang: Record<string, BookPageLangContent> = {};
  for (const langId of enabledLangIds) {
    byLang[langId] = defaultPageLangContent();
  }
  return {
    clientId: crypto.randomUUID(),
    page_number: pageNumber,
    image_path: '',
    video_path: '',
    image_file: null,
    byLang,
  };
}

export function clonePageDraft(
  source: BookPageDraft,
  newPageNumber: number,
  enabledLangIds: string[],
): BookPageDraft {
  const byLang: Record<string, BookPageLangContent> = {};
  for (const langId of enabledLangIds) {
    const src = source.byLang[langId];
    byLang[langId] = src
      ? {
          full_text: typeof src.full_text === 'string' ? src.full_text : '',
        }
      : defaultPageLangContent();
  }
  return {
    clientId: crypto.randomUUID(),
    page_number: newPageNumber,
    image_path: source.image_path,
    video_path: source.video_path,
    image_file: null,
    byLang,
  };
}

export function ensurePageLangKeys(page: BookPageDraft, enabledLangIds: string[]): BookPageDraft {
  const byLang = { ...page.byLang };
  for (const langId of enabledLangIds) {
    if (!byLang[langId]) {
      byLang[langId] = defaultPageLangContent();
    }
  }
  return {
    ...page,
    image_path: page.image_path ?? '',
    video_path: page.video_path ?? '',
    image_file: page.image_file ?? null,
    byLang,
  };
}

export function targetCodesForTranslate(otherLanguages: { id: string; code?: string }[]): string[] {
  return otherLanguages.map((l) => (l.code?.trim() ? l.code.trim() : l.id));
}
